export default __webpack_public_path__ + "static/media/logo_final_white.0fe679d1.png";